import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userContextDetailSlice from "./slices/userContextSlice"
import invDataSlice from "./slices/investmentSlice";
import allStandardTenatDataSlice from "./slices/allStandardTenantSlice";
import propertyDataSlice from "./slices/propertyslice";
import properManagerSlice from "./slices/propertyManagerSlice";
import allSelectedDataSlice from "./slices/allSelectedDataSlice";
import formValidationSlice from "./slices/formValidationSlice";
import leaseDatabyIdSlice from "./slices/leaseByIdSlice";
import AmendmentTenatByPropertyDataSlice from "./slices/AmendmentTenatByPropertyDataSlice";


const rootReducer = combineReducers({
  userContextDetails: userContextDetailSlice,
  invData: invDataSlice,
  allStandardTenant: allStandardTenatDataSlice,
  propertyData: propertyDataSlice,
  propertyManagerData: properManagerSlice,
  allSelectedData: allSelectedDataSlice,
  formValidation: formValidationSlice,
  leaseDatabyId : leaseDatabyIdSlice,
  tenantByPropertyData : AmendmentTenatByPropertyDataSlice
});


export const makeStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof makeStore>
export type AppDispatch = AppStore['dispatch']


export const store = makeStore();
